import { useContext } from "react";
import UserSettingsContext from "../contexts/UserSettingsContext";

const useCurrentUserSettings = () => {
  return useContext(UserSettingsContext);
};

export default useCurrentUserSettings;
